import { selectedChangeForEdit } from "./selectedChangeForEdit";
import {changeArea} from './changeArea';
import {changeType} from './changeType';

export let reducers = {
    selectedChangeForEdit,
    changeArea,
    changeType
}
